import { Link } from "react-router-dom";

const G = {
  surface: "#111111", border: "#1E1E1E", text: "#E4E4DC",
  muted: "#666", accent: "#00C896",
  font: "'Sora', sans-serif", mono: "'DM Mono', monospace",
};

export default function SignInPrompt({ action = "continue", inline = false, onClose }) {
  const buttons = (
    <div style={{ display:"flex", gap:8, justifyContent:"center" }}>
      <Link to="/login" style={{ background:"#1A1A1A", border:"1px solid #2A2A2A", color:G.text, padding:"8px 18px", borderRadius:20, textDecoration:"none", fontSize:13, fontFamily:G.mono, fontWeight:600 }}>Sign In</Link>
      <Link to="/register" style={{ background:G.accent, color:"#000", padding:"8px 18px", borderRadius:20, textDecoration:"none", fontSize:13, fontFamily:G.mono, fontWeight:700 }}>Create Account</Link>
    </div>
  );

  if (inline) {
    return (
      <div style={{ background:G.surface, border:`1px solid ${G.border}`, borderRadius:8, padding:16, textAlign:"center" }}>
        <p style={{ color:G.text, fontSize:14, margin:"0 0 14px" }}>Sign in to {action}</p>
        {buttons}
      </div>
    );
  }

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999, padding:16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:G.surface, border:`1px solid ${G.border}`, borderRadius:16, padding:28, textAlign:"center", maxWidth:340, width:"100%", position:"relative" }}>
        {onClose && (
          <button onClick={onClose} aria-label="Close" style={{ position:"absolute", top:10, right:12, background:"none", border:"none", color:G.muted, fontSize:16, cursor:"pointer" }}>✕</button>
        )}
        <p style={{ color:G.text, fontSize:16, fontWeight:600, margin:"0 0 18px" }}>Sign in to {action}</p>
        {buttons}
      </div>
    </div>
  );
}
